import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_DOCUMENTS,
  GET_DOCUMENT_BY_ID,
  ADD_DOCUMENT,
  DELETE_DOCUMENT,
} from "./actionTypes"

import {
  getDocumentsSuccess,
  getDocumentsFail,
  getDocumentByIdSuccess,
  getDocumentByIdFail,
  addDocumentSuccess,
  addDocumentFail,
  deleteDocumentSuccess,
  deleteDocumentFail,
} from "./actions"

import {
  getDocumentsApi,
  getDocumentByIdApi,
  addDocumentApi,
  deleteDocumentApi,
} from "helpers/backend_helper"

function* fetchDocuments({ payload: { entityId, entityType } }) {
  try {
    const response = yield call(getDocumentsApi, entityId, entityType)
    yield put(getDocumentsSuccess(response))
  } catch (error) {
    yield put(getDocumentsFail(error))
  }
}

function* fetchDocumentById({ payload: id }) {
  try {
    const response = yield call(getDocumentByIdApi, id)
    yield put(getDocumentByIdSuccess(response))
  } catch (error) {
    yield put(getDocumentByIdFail(error))
  }
}

function* onAddDocument({ payload: formData }) {
  try {
    const response = yield call(addDocumentApi, formData)
    yield put(addDocumentSuccess(response))
  } catch (error) {
    yield put(addDocumentFail(error))
  }
}

function* onDeleteDocument({ payload: id }) {
  try {
    yield call(deleteDocumentApi, id)
    yield put(deleteDocumentSuccess(id))
  } catch (error) {
    yield put(deleteDocumentFail(error))
  }
}

function* DocumentsSaga() {
  yield takeEvery(GET_DOCUMENTS, fetchDocuments)
  yield takeEvery(GET_DOCUMENT_BY_ID, fetchDocumentById)
  yield takeEvery(ADD_DOCUMENT, onAddDocument)
  yield takeEvery(DELETE_DOCUMENT, onDeleteDocument)
}

export default DocumentsSaga
